import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BudgetModel} from '@cas-hub/acabim-financial-client';
import {LTMSProjectDatatableItem} from '../../../_models/ltms.model';
import {LtmsService} from '../../../_services/ltms.service';
import {
    ColumnFilter,
    DataTableColumnData, DatatableComponent,
    DataTableConfig, DataTableDataSource, DataTableObservableCompletionListener,
    DataTableObservableDataSource,
    DataTableObservableErrorListener,
    DataTableObservableRefresher,
    TableAction
} from '@cas-hub/acabim-common-client';
import {map} from 'rxjs/operators';
import {CurrencyPipe} from '@angular/common';

export interface BudgetModelDisplay extends BudgetModel {
    amountDisplay: string;
}

@Component({
    selector: 'acabim-admin-manage-budget-details',
    templateUrl: './manage-budget-details.component.html',
    styleUrls: ['./manage-budget-details.component.scss']
})
export class ManageBudgetDetailsComponent implements OnInit {

    ltmItem: LTMSProjectDatatableItem | null = null
    @Input() set currentReport(value: LTMSProjectDatatableItem) {
        this.ltmItem = value;
        if (value) {
            this._currentGUID = value.id;
            if (this.dataTable) {
                this.dataTable.requestImmediateDataRefresh();
            }
        }
    }
    @Output() closeModal = new EventEmitter<string>();

    constructor(
        private readonly ltmsService: LtmsService,
        private readonly _currencyPipe: CurrencyPipe
    ) {}

    _currentSelection?: BudgetModel;
    currentYear: number = (new Date()).getFullYear();
    _currentGUID = '';
    showModal = false;
    index = 0;
    public dataSources: DataTableDataSource<any>[] = [];
    @ViewChild('expenditureTable') public expenditureTable?: DatatableComponent;
    @ViewChild('dataTable') public dataTable?: DatatableComponent;
    type?: 'budget' | 'expenditure';
    // budgetHeading = 'Manage Budget for' + this.currentReport?.name;
    expenditureDataSources: DataTableDataSource<any>[] = [];
    modalTitle = '';

    private dataRefresher(): DataTableObservableRefresher<BudgetModelDisplay> {
        return () => this.ltmsService.getBudgetForItem(this._currentGUID).pipe(map(a => {
            console.dir(a);
            return a.map(b => {
                const amount =  b.amount ?? 0;
                const tmp: BudgetModelDisplay = {
                    id: b.id,
                    year: b.year,
                    amount: b.amount,
                    amountDisplay: this._currencyPipe.transform(amount) ?? ''
                }
                return tmp;
            });
        }));
    }

    private expenditureDataRefresher(): DataTableObservableRefresher<BudgetModelDisplay> {
        return () => this.ltmsService.getExpenditureForItem(this._currentGUID).pipe(map(a => {
            console.dir(a);
            return a.map(b => {
                const amount =  b.amount ?? 0;
                const tmp: BudgetModelDisplay = {
                    id: b.id,
                    year: b.year,
                    amount: b.amount,
                    amountDisplay: this._currencyPipe.transform(amount) ?? ''
                }
                return tmp;
            });
        }));
    }

    ngOnInit(): void {
        this.dataSources[0] = new BudgetDS(this.dataRefresher(), undefined, undefined, action => {
        });
        this.expenditureDataSources[0] = new BudgetDS(this.expenditureDataRefresher(), undefined, undefined, action => {
        }, 'No Expenditure Found');
    }

    addBudget() {
        this._currentSelection = undefined;
        this.modalTitle = 'Add Budget';
        this.type = 'budget';
        this.toggleModalStatus(true);
    }

    addExpenditure() {
        this._currentSelection = undefined;
        this.type = 'expenditure';
        this.modalTitle = 'Add Expenditure';
        this.toggleModalStatus(true);
    }

    toggleExpenditureStatus(b: boolean) {
        this.type = 'expenditure';
        this._currentSelection = this.expenditureDataSources[0].detailData;
        this.modalTitle = 'Edit Expenditure';
        this.toggleModalStatus(true);
    }

    toggleBudgetStatus(b: boolean) {
        this.type = 'budget';
        this._currentSelection = this.dataSources[0].detailData;
        this.modalTitle = 'Edit Budget';
        this.toggleModalStatus(true);
    }

    toggleModalStatus($event: boolean) {
        this.showModal = $event;
        if (!$event) {
            this._currentSelection = undefined;
        }
    }

    close() {
        this.closeModal.emit('close');
    }

    selectTab($event: any) {
        this.index = $event.index;
        if ($event.index === 0) {
            this.dataTable?.requestImmediateDataRefresh();
        } else {
            this.expenditureTable?.requestImmediateDataRefresh();
        }
    }

    modalCloseEvent($event: string) {
        this.showModal = false;
        if ($event === 'budget' || $event === 'expenditure') {
            this.dataTable?.requestImmediateDataRefresh();
        }
    }
}

export class BudgetDS<T extends BudgetModelDisplay> extends DataTableObservableDataSource<T> {
    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Year', objectPropertyName: 'year', textAlign: 'center', colWidth: '7rem'},
            {displayName: 'Amount', objectPropertyName: 'amountDisplay', textAlign: 'flex-end', colWidth: '8rem'},
        ];
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [];
    emptyMessage = 'No Budget Found';

    onDataExpanded(value: BudgetModelDisplay): void {
    }

    constructor(
        readonly dataRefresher: DataTableObservableRefresher<T>,
        readonly observableErrorListener?: DataTableObservableErrorListener,
        readonly observableCompleteListener?: DataTableObservableCompletionListener,
        readonly actionListener?: (action: TableAction) => void,
        emptyMessage: string = 'No Budget Found') {
        super(() => this.dataRefresher(),
            undefined, undefined);
        this.emptyMessage = emptyMessage;

        this.config = {
            tableHeading: '',
            isSearchEnabled: false,
            searchPlaceHolder: '',
            emptyMessage: this.emptyMessage,
            globalFilterFields: [],
            hasCheckbox: false,
            hasDetailsButton: true,
            isLazyLoadingEnabled: false,
            isPaginationEnabled: false,
            hasFilters: false,
            isExportEnabled: false,
            hasActions: false
        };
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }
}
